module.exports = __webpack_public_path__ + "static/media/Groceries.999d950f.jpg";